/**
 * Sets focus to an element asynchronously. The focus will be set
 * at the next browser repaint to not cause any extra recalculations.
 * If we call this more than once in the same frame, only the latest called
 * will be focused
 */

let targetToFocusOnNextRepaint = undefined

export default function focusAsync(el, elHeight = 0) {
	if (el) {
		// An element has already been queued to be focused, so we replace it
		if (targetToFocusOnNextRepaint) {
			targetToFocusOnNextRepaint = el
			return
		}

		targetToFocusOnNextRepaint = el

		// el.focus() is always a no-op if the element no longer exists
		// in the dom, so this is always safe
		window.requestAnimationFrame(() => {
			targetToFocusOnNextRepaint && targetToFocusOnNextRepaint.focus()
      targetToFocusOnNextRepaint && targetToFocusOnNextRepaint.scrollIntoView()
			const scrolledY = window.scrollY
			if (scrolledY) {
        window.scroll(0, scrolledY - elHeight);
      }
			if (el.tagName.toLowerCase() === 'input') {
				el.select()
			}
			targetToFocusOnNextRepaint = undefined
		})
	}
}
